<template>
    <form class="discount-code-form" aria-label="Discount code form">
            <div class="input-folder">
                <div class="input-folder--input">
                    <input type="text" v-model="localCouponCode" id="discountCode" placeholder=" " aria-label="Enter discount code" required>
                    <label for="discountCode">
                        <p class="paragraph-default">Discount Code</p>
                    </label>
                </div>
                <div class="input-folder"><span class="input-support-text coupon-success" v-if="applied">Code successfully applied to your order!</span></div>
                <div class="input-folder"><span class="input-support-text coupon-error" v-if="couponError">Code is invalid or does not apply to your order</span></div>
            </div>
            <button type="button" @click="applyCoupon" :class="localCouponCode ? `primary` : `bg-rothcoMedGray text-rothcoCharcoal`" aria-label="Apply discount code">
                Apply
            </button>
     </form>
</template>

<script lang="ts" setup>
    import { ref, inject } from "vue";
    import { useLists } from "@/helpers/composables/useList";
    import { router } from "@inertiajs/vue3";
    let route = inject('route');
    let { applyCouponOnList } = useLists({ router, route});

    let { couponCode } = defineProps({
        couponCode: {
            type: String<any>,
            default: ""
        }
    });

    const applied = ref(false);
    const couponError = ref(false);

    let localCouponCode = ref(couponCode);

    const applyCoupon = function () {
        applyCouponOnList(localCouponCode.value, {
            afterFetch: (ctx) => {
                const response = ctx.data;
                applied.value = response.applied;
                couponError.value = !response.applied;
            }
        });
    };
</script>
